import React from "react";
import dishData from "../data/barbequeen-special-dish.json";
import dishImg from "../assets/uploads/home_page/special-06-12-2025-1749716254.webp";

const { subtitle, title, description } = dishData.section;

/* ─── Feature cards shown on the right ─────────────────────────── */
const features = [
  {
    title: "Double Marinated",
    description:
      "Every piece is marinated twice for maximum depth of flavour — soaking in our secret spice blend for hours before hitting the grill.",
    icon: (
      <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
      </svg>
    ),
  },
  {
    title: "Authentic Grill Style",
    description:
      "Slow-cooked over live charcoal using traditional tandoori & barbeque techniques perfected since 1999.",
    icon: (
      <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 22V12h6v10" />
      </svg>
    ),
  },
  {
    title: "Chef's Signature",
    description:
      "Handcrafted by our expert chefs who bring 25+ years of experience in Indian, Chinese & barbeque cuisine.",
    icon: (
      <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 3a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2H5z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4" />
      </svg>
    ),
  },
  {
    title: "Dine-in & Delivery",
    description:
      "Enjoy the full experience at our restaurant or order for takeaway and online delivery right to your doorstep.",
    icon: (
      <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ),
  },
];

/* ─── Main Component ────────────────────────────────────────────── */
const SpecialDishSection = () => {
  return (
    <section id="special-dish" className="py-20 bg-[#0a0705] overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">

          {/* ── Left Side: Intro + Image ── */}
          <div className="lg:col-span-5 space-y-6">
            <div>
              <p className="font-sans text-[11px] font-bold tracking-[0.25em] text-[#c0424e] uppercase mb-3">
                {subtitle}
              </p>
              <h2 className="text-[32px] sm:text-[40px] font-bold text-white leading-tight uppercase tracking-wide">
                {title}
              </h2>
              <div className="mt-4 w-12 h-0.5 bg-[#9b1c2e]" />
            </div>

            <p className="font-sans text-[14px] text-gray-300 leading-relaxed">
              {description}
            </p>

            {/* Dish Image */}
            <div className="relative h-[280px] sm:h-[340px] rounded-xl overflow-hidden shadow-lg group">
              <img
                src={dishImg}
                alt={title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                onError={(e) => {
                  e.target.src =
                    "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?q=80&w=800&auto=format&fit=crop";
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />

              {/* Overlay label */}
              <div className="absolute bottom-4 left-4">
                <span className="inline-block bg-[#9b1c2e] text-white text-[10px] font-bold tracking-widest uppercase px-3 py-1.5 rounded-md">
                  Today's Special
                </span>
              </div>
            </div>
          </div>

          {/* ── Right Side: Feature Cards Grid ── */}
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-white backdrop-blur-sm p-8 rounded-xl border border-white/5 shadow-sm hover:shadow-md transition-all duration-300 group hover:-translate-y-1 hover:border-[#9b1c2e]/30"
              >
                <div className="w-14 h-14 rounded-xl bg-black flex items-center justify-center mb-6 text-white group-hover:bg-[#9b1c2e] group-hover:text-white transition-colors duration-300">
                  {feature.icon}
                </div>

                <h3 className="text-[16px] font-bold text-black uppercase tracking-wide mb-3">
                  {feature.title}
                </h3>

                <p className="font-sans text-[13px] text-black leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default SpecialDishSection;

